import { createUserManager } from 'redux-oidc';

const UserManagerConfig = {
    client_id: '2244c639-ceb4-43c4-94dd-26add25bbf9f', //WEB Client ID BOBST UAT
    redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/callback`,
    post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/userlogin`,
    response_type: 'code',
    scope: '8a6084aa-95d9-46ac-95cb-1db7b245ece9/user_impersonation',
    authority: 'https://login.microsoftonline.com/4a40c135-940f-4399-8f61-b602ad37c248/v2.0/.well-known/openid-configuration',
    silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/silentrenew`,
    automaticSilentRenew: true,
    includeIdTokenInSilentRenew: false,
    filterProtocolClaims: true,
    loadUserInfo: false,
    revokeAccessTokenOnSignout: true,
    silentRequestTimeout: 100000,
    accessTokenExpiringNotificationTime: 300
};

const _UserManager = createUserManager(UserManagerConfig);

export default _UserManager;
